import React, { useEffect } from 'react';

import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
'@keyframes pulse': {
  '0%': {
    transform: 'scale(1)',
    opacity: '1',
  },
  '11%': {
    transform: 'scale(1.05)',
    opacity: '0.7',
  },
  '33%': {
    transform: 'scale(1)',
    opacity: '1',
  },
  '100%': {
    transform: 'scale(1)',
    opacity: '1',
  },
},

pulse: {
  animation: '$pulse 3.5s infinite',
},
}));

export const NavatticButtonPopUp = ({
  dataNavatticTitle = '',
  dataNavatticOpen = '',
  ctaText = 'Take A Tour',
}) => {
  const classes = useStyles();

  useEffect(() => {
    if (typeof window === 'undefined' || !window.NavatticEmbed) return;

    const button = document.getElementById('demo');
    if (!button) return;

    const navatticUrl = button.getAttribute('data-navattic-open');
    const navatticTitle = button.getAttribute('data-navattic-title');

    if (!navatticUrl || !navatticTitle) {
      console.warn('Missing data-navattic-* attributes');
      return;
    }

    const config = { title: navatticTitle };
    window.NavatticEmbed.initPopup(navatticUrl, config);

    const handleClick = () => {
      window.NavatticEmbed.openPopup(navatticUrl);
    };

    button.addEventListener('click', handleClick);

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            node.tagName === 'IFRAME' &&
            node.src.includes('navattic')
          ) {
            console.log('✅ Navattic popup appeared:', node);
          }
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      button.removeEventListener('click', handleClick);
    };
  }, []);
  return (
    <Button
      color='secondary'
      size='large'
      variant='contained'
      id='demo'
      className={classes.pulse}
      data-navattic-title={dataNavatticTitle}
      data-navattic-open={dataNavatticOpen}
    >
      {ctaText}
    </Button>
  );
};